import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

// Risk-reversal, framed as confidence rather than compensation. Deliberately
// calm and understated — no loud badges or countdowns, which read as
// desperation/scam to cold traffic. Paired with the 10-year track record so
// the return policy reads as "we stand behind this."
const Guarantee = () => {

    const assurances = [
        {
            icon: 'fas fa-undo',
            title: '14-day returns',
            copy: 'Not the right fit? Send it back within 14 days for a refund. Simple and no run-around.',
        },
        {
            icon: 'fas fa-shield-alt',
            title: 'Manufacturer warranty',
            // TODO: insert the exact warranty term (e.g. "1-year") once confirmed.
            copy: 'Every device is backed by our manufacturer warranty against defects.',
        },
        {
            icon: 'fas fa-headset',
            title: 'U.S.-based support',
            copy: 'Real people who know the product — the same team that has protected homes for a decade.',
        },
    ];

    return (
        <section id={'guarantee'} style={{
            backgroundColor: Appearance.colors.white,
            width: '100%',
        }}>
            <div style={{
                maxWidth: Appearance.layout.maxWidth,
                margin: '0 auto',
                padding: Appearance.layout.sectionPadding(),
                textAlign: 'center',
            }}>

                <span style={{ ...Appearance.textStyles.label(), marginBottom: 14, display: 'block' }}>
                    {'Buy with confidence'}
                </span>
                <h2 style={{ ...Appearance.textStyles.sectionHeading(), marginBottom: 16 }}>
                    {'Try it risk-free'}
                </h2>
                <p style={{ ...Appearance.textStyles.sectionSubheading(), margin: `0 auto ${Utils.isMobile() ? 40 : 52}px auto` }}>
                    {'We\'ve protected homes for over 10 years, and we stand behind every device we ship. If it isn\'t right for your home, sending it back is easy.'}
                </p>

                <div style={{
                    display: 'grid',
                    gridTemplateColumns: Utils.isMobile() ? '1fr' : 'repeat(3, 1fr)',
                    gap: Utils.isMobile() ? 20 : 28,
                    textAlign: 'left',
                }}>
                    {assurances.map((item, index) => (
                        <div key={index} style={{
                            ...Appearance.styles.card(),
                            padding: Utils.isMobile() ? 24 : 28,
                            boxShadow: Appearance.boxShadow.card,
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                                <i className={item.icon} style={{ fontSize: 19, color: Appearance.colors.primary(), flexShrink: 0 }} />
                                <h3 style={{ ...Appearance.textStyles.subHeading({ fontSize: 18 }), margin: 0 }}>
                                    {item.title}
                                </h3>
                            </div>
                            <p style={Appearance.textStyles.body({ fontSize: 14 })}>
                                {item.copy}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Guarantee;
